import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
    },
    formTitle: {
        fontFamily: "Source Sans 3 !important",
        fontWeight: "600 !important",
        color: theme.palette.secondary.dark,
        fontSize: "32px !important",
    },
    fieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        justifyContent: "center",
        alignItems: "center",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    formSubtitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    listContainer: {
        paddingLeft: "64px !important",
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
        "& > div:last-child": {
            boxShadow: "none !important",
        },
    },
    listItem: {
        display: "flex",
        marginBottom: "10px",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: 600,
            color: theme.palette.secondary.dark,
        },
    },
    chips: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
        "&.MuiFormControl-root .MuiInputBase-root .MuiChip-root": {
            background: "#EF3340",
            color: "white",
        },
        "&.MuiFormControl-root .MuiInputBase-root .MuiChip-root .MuiChip-deleteIcon": {
            color: "white",
        },
    },
    separator: {
        paddingBottom: "20px",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    administratorContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        width: "100%",
        color: theme.palette.secondary.dark,
        fontSize: "16px",
    },
    submitButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px !important",
            fontFamily: "Source Sans 3",
            marginBottom: "30px",
            "&:hover": {
                background: theme.palette.info.light,
            },
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
}));
